// src/utils/logger.js

/**
 * A development-only logger that wraps the console.
 * In production builds, these functions are stripped out, preventing
 * sensitive information from being logged in the user's console.
 */

const log = (...args) => {
  if (__DEV__) {
    console.log(...args);
  }
};

const warn = (...args) => {
  if (__DEV__) {
    console.warn(...args);
  }
};

const error = (...args) => {
  if (__DEV__) {
    console.error(...args);
  }
};

const logger = {
  log,
  warn,
  error,
};

export default logger;
